


























import Vue from "vue";
import AdvertisementPreview from "@/components/Form/AdvertisementPreview.vue";
import Advertisement from "../../../entity/Advertisement";
import Course from "../../../entity/Course";
import Region from "../../../entity/Region";
import Locality from "../../../entity/Locality";
export default Vue.extend({
  components: { AdvertisementPreview },
  computed: {
    documentMd() {
      return `
# 管理者 広告修正完了

* 同時に承認済みとなる
`;
    }
  },
  data() {
    return {
      advertisement: (() => {
        const adv = new Advertisement();
        adv.title = "家を売るならgoguyホーム";
        adv.body1 = "家を売るならgoguyホーム";
        return adv;
      })()
    };
  }
});
